import { render } from "./ModalBattlesModes.vue?vue&type=template&id=2c4a1ecb&scoped=true"
import script from "./ModalBattlesModes.vue?vue&type=script&lang=js"
export * from "./ModalBattlesModes.vue?vue&type=script&lang=js"

import "./ModalBattlesModes.vue?vue&type=style&index=0&id=2c4a1ecb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4a1ecb"]])

export default __exports__